import { useAuthStore } from '@unsw/store/auth'

/**
 * Get user role information (non-hook version for use in route beforeLoad)
 * Use this in route guards where React hooks cannot be used
 */
export function getUserRole() {
  const { user, activeRole } = useAuthStore.getState()

  const isTeacher = activeRole === 'teacher' || user?.status === 'TEACHER'
  const isStudent = user?.status === 'STUDENT'
  const isAdmin = activeRole === 'admin' || user?.roles?.some((r) => r.name === 'SuperAdmin')

  return { user, isTeacher, isStudent, isAdmin, activeRole }
}
